export default __webpack_public_path__ + "static/resqvest-0864f8f6f72bf1262954fb70b0f176bd.svg";